import { initialNormalizedObjects, INormalizedObjects } from '../normalizedObjects';

export interface IGroupState {
    groups: IGroups;
    members: INormalizedObjects<IMembers>;
    meetings: INormalizedObjects<IMeeting[]>;
    messages: INormalizedObjects<IGroupMessage[]>;
    currentGroup?: string;
}

export interface IGroups {
    isLoading: boolean;
    isLoaded: boolean;
    groups: INormalizedObjects<IGroup>;
}

export interface IGroup {
    alias: string | null;
    id: string;
    name: string;
    icon: string | null;
    description: string | null;
    reference: string | null;
    enabled: boolean;
    companyId: number | null;
    showMembers: boolean;
    showMembersInfo: string;
    canSendEmail: string;
    sendIntroMessage: boolean;
    canEditResponsible: boolean;
}

export interface IMembers {
    isLoading: boolean;
    members: INormalizedObjects<IGroupMember>;
}

export interface IBusinessCard {
    companyId: number;
    companyName: string;
    email: string;
    mobile: string;
    personAlias: string;
    personId: number;
    personImageUrl: string;
    personName: string;
    phone: string;
    title: string;
}

export interface IDocument {
    id: string;
    fileName: string;
    mimeType: string;
    size: number;
    creatorDiNumber: number | null;
    creatorEmail: string;
    groupId: string;
    isFavorite: boolean;
}

export interface IParticipantStatus {
    member: IGroupMember;
    status: string;
    reply: string;
}

export interface IMeeting {
    groupId: string;
    meetingId: string;
    subject: string;
    location: string;
    startTime: string;
    endTime: string;
    status: string;
    description: string;
    htmlBody: string;
    creator: IGroupMember;
    participantStatuses: IParticipantStatus[];
    documents: IDocument[];
    expired: boolean;
    links: IEmailLink[];
}

export interface IMember {
    alias: string;
    description: string;
    diNumber: number;
    familyName: string;
    fullName: string;
    givenName: string;
    imageUrl: string;
    linkedInUrl: string;
    showGreeting: boolean;
    lastUpdated: string;
    alternateEmails: string[];
    descriptionGroups: string[];
}

export interface IMessageEvent {
    personId: number;
    email: string;
    event: string;
}

export interface IGroupMember extends IMember {
    businessCard?: IBusinessCard;
    role: string;
    bounce: IBounceInfo;
       
}

export interface IBounceInfo {
    type: string;
    status: string;
    email: string;
    timestamp: string; 
    active: boolean;
    count: number;
}

export interface IEmailAttachment extends IDocument {
    contentId: string | null;
}

export interface IGroupMessage {
    created: string;
    groupId: string;
    messageId: string;
    parentId: string | null;
    threadId: string;
    subject: string;
    emailType: string;
    htmlBody: string;
    messageCreator: IBusinessCard | null;
    fromName: string | null;    
    attachments: IEmailAttachment[];
    messageEvents: IMessageEvent[] | null;
}

export interface IEmailLink {
    typeId: string;
    icon: string;
    text: string;
    link: string;
}

export const initialGroupState: IGroupState = {
    groups: {
        groups: initialNormalizedObjects,
        isLoading: false,
        isLoaded: false
    },
    members: initialNormalizedObjects,
    meetings: initialNormalizedObjects,
    messages: initialNormalizedObjects,
    currentGroup: undefined
}